/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Are_You_Sure_Render_AllInputs */

const en_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to render all Events?`)
};

const fr_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir effectuer le rendu de tous les événements ?`)
};

const de_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie wirklich alle Ereignisse rendern?`)
};

const it_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler visualizzare tutti gli eventi?`)
};

const ru_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите отобразить все события?`)
};

const es_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro que deseas representar todos los eventos?`)
};

const zh_cn2_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要渲染所有事件吗？`)
};

const ja_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのイベントをレンダリングしてもよろしいですか?`)
};

const hi_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई सभी इवेंट्स को रेंडर करना चाहते हैं?`)
};

const pt_pt2_are_you_sure_render_all = /** @type {(inputs: Are_You_Sure_Render_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja renderizar todos os eventos?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to render all Events?" |
*
* @param {Are_You_Sure_Render_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const are_you_sure_render_all = /** @type {((inputs?: Are_You_Sure_Render_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Are_You_Sure_Render_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_are_you_sure_render_all(inputs)
	if (locale === "de") return de_are_you_sure_render_all(inputs)
	if (locale === "it") return it_are_you_sure_render_all(inputs)
	if (locale === "ru") return ru_are_you_sure_render_all(inputs)
	if (locale === "es") return es_are_you_sure_render_all(inputs)
	if (locale === "zh-CN") return zh_cn2_are_you_sure_render_all(inputs)
	if (locale === "ja") return ja_are_you_sure_render_all(inputs)
	if (locale === "hi") return hi_are_you_sure_render_all(inputs)
	if (locale === "pt-PT") return pt_pt2_are_you_sure_render_all(inputs)
	return en_are_you_sure_render_all(inputs)
});